<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark">
      <div class="container-xl">
        <div class="navbar-brand">1Click : Easy to Get Information & Connection</div>
      </div>
    </nav>

    <div class="container pb-1">
      <div class="row pt-3">

        <div class="col-12 order-md-1">
          <h4 class="mb-3">{{ showName }}</h4>

          <p>{{$t('userTrackingResult.description1')}}</p>

          <div class="d-flex flex-column mb-2">
            <img :src="boothCompanyLogo" class="img-thumbnail storelogo mt-3 mb-3 mx-auto" style="max-width: 45%; height: auto">
            <h3 class="mx-auto">{{ boothName }}</h3>
            <h5 class="mx-auto text-black-50">{{ exhibitionArea }}</h5>
          </div>


          <div v-if="boothContactPerson !== null" class="mb-2 row">
            <div class="col-auto"><span class="material-icons">account_circle</span></div>
            <div class="col-auto">{{boothContactPerson}}</div>
          </div>

          <div v-if="boothContactNumber !== null" class="mb-2 row">
            <div class="col-auto"><span class="material-icons">phone_iphone</span></div>
            <div class="col-auto">{{boothContactNumber}}</div>
          </div>

          <div v-if="boothOfficialSite !== null" class="mb-2 row">
            <div class="col-auto"><span class="material-icons">home</span></div>
            <div class="col-auto">{{ boothOfficialSite }}</div>
          </div>

          <div v-if="boothAddress !== null" class="mb-2 row">
            <div class="col-auto"><span class="material-icons">pin_drop</span></div>
            <div class="col-auto">{{ boothAddress }}</div>
          </div>

          <div v-if="cataloguesUrl !== null" class="mb-2 row">
            <div class="col-auto"><span class="material-icons">description</span></div>
            <div class="col-auto"><a :href="cataloguesUrl" target="_blank">{{$t('userTrackingResult.openAttachment')}}</a></div>
          </div>
        </div>
      </div>
      <div class="login_power">©2014-2022 Young Square Createch Ltd.</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BoothBoardAdmission",
  data: function () {
    return {
      userName: "",
      showName: "",
      boothName: "",
      boothProfileType: "",
      boothCompanyLogo: "",
      boothContactPerson: "",
      boothContactNumber: "",
      boothOfficialSite: "",
      boothAddress: "",
      exhibitionArea: "",
      showId: "",
      createDate: null,
      catalogues: null,
      cataloguesUrl: null,
    };
  },
  created() {
    this.userName = this.$route.params.USER_NAME;
    this.showName = this.$route.params.SHOW_NAME;
    this.boothName = this.$route.params.BOOTH_NAME;
    this.boothProfileType = this.$route.params.PROFILE_TYPE;
    this.showId = this.$route.params.SHOW_SID;
    this.createDate = this.$route.params.CREATE_DATE;
    this.catalogues = this.$route.params.CATALOGUES;
    this.boothContactPerson = this.$route.params.CONTACT_PERSON;
    this.boothContactNumber = this.$route.params.CONTACT_NUMBER;
    this.boothOfficialSite = this.$route.params.OFFICIAL_SITE;
    this.boothAddress = this.$route.params.ADDRESS;
    this.exhibitionArea = this.$route.params.EXHIBITION_AREA;
    this.boothCompanyLogo = this.$route.params.BOOTH_COMPANY_LOGO;
    if(this.catalogues.FILEURL !== "") {
      this.cataloguesUrl = '/catalogues/' + this.showId + "/" + this.catalogues.FILEURL;
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
  },
};
</script>

<style scoped></style>
